import { render, staticRenderFns } from "./AppointmentButton.vue?vue&type=template&id=123813c0&scoped=true"
import script from "./AppointmentButton.vue?vue&type=script&lang=js"
export * from "./AppointmentButton.vue?vue&type=script&lang=js"
import style0 from "./AppointmentButton.vue?vue&type=style&index=0&id=123813c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123813c0",
  null
  
)

export default component.exports